/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import React, {Component} from "react";

export default class EmptyShell extends Component {
  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ../render/customApplications/emptyShell.jsx